import { render, staticRenderFns } from "./sweetStake.vue?vue&type=template&id=1aad577a&scoped=true&"
import script from "./sweetStake.vue?vue&type=script&lang=js&"
export * from "./sweetStake.vue?vue&type=script&lang=js&"
import style0 from "./sweetStake.vue?vue&type=style&index=0&id=1aad577a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aad577a",
  null
  
)

export default component.exports